<template>
  <ValidationObserver
    ref="signupFormObserver"
    v-slot="{ valid }"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <VTextField
          v-model="data.firstName"
          :label="$t('forms.labels.firstName')"
          :rules="{ required: true, min: 1, max: 200 }"
          :dark="true"
          color="#ffffff"
        />
      </v-col>
      <v-col>
        <VTextField
          v-model="data.lastName"
          :label="$t('forms.labels.lastName')"
          :rules="{ required: true, min: 1, max: 200 }"
          :dark="true"
          color="#ffffff"
        />
      </v-col>
    </v-row>
    <VTextField
      v-model="data.email"
      :label="$t('forms.labels.email')"
      type="email"
      :rules="{ required: true, min: 1, max: 200 }"
      :disabled="true"
      :dark="true"
      color="#ffffff"
    />
    <VPassword
      v-model="data.password"
      :label="$t('forms.labels.password')"
      :passwordConfirm="true"
      :dark="true"
      color="#ffffff"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VPassword from '@/components/shared/widgets/forms/VuetifyInputs/VPassword.vue';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VTextField,
        VPassword,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    data() {
        return {
            data: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                invitationCode: '',
                locale: '',
                team: {},
            },
        };
    },
    watch: {
        userInvitation(invitation) {
            if (!invitation) return;
            Object.assign(this.data, invitation.user.profile);
            try {
                this.data.id = invitation.user.id;
                this.data.verificationCode = invitation.verificationCode;
                this.data.invitationCode = invitation.invitationCode;
                this.data.team = {
                    name: invitation.team.name,
                    id: invitation.team.id,
                };
                this.data.locale = invitation.user.preferences.locale;
            } catch (err) {
                this.$store.commit('setFrontEndError', { key: 'invalid_url' });
            }
        },
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    created() {
        if (!this.$store.getters.verificationCode || this.$store.getters.verificationCode === '') {
            return;
        }
        if (!this.$store.getters.invitedUser) {
            return;
        }
        this.data.verificationCode = this.$store.getters.verificationCode;
        this.data.id = this.$store.getters.invitedUser.id;
        this.data.email = this.$store.getters.invitedUser.email;
        this.data.firstName = this.$store.getters.invitedUser.firstName;
        this.data.lastName = this.$store.getters.invitedUser.lastName;
        if (this.$store.getters.invitedUser.preferences) {
            this.data.locale = this.$store.getters.invitedUser.preferences.locale;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
